/*
 * 区分コード情報
 */
const route = {
  name: "CategoryCodeMaster",
  path: "/categorycodemaster",
  view: "CategoryCodeMaster",
  component: () =>
      import ("../CategoryCodeMaster.vue"),
  meta: {
      title: "区分コード情報"
  }
}

export default route